import React from 'react';
import { Row } from 'antd';
import { ActionsInline } from './styles';
import type { ActionItem } from './types';

interface InlineActionsProps {
	items: ActionItem[];
}

export function InlineActions({ items }: Readonly<InlineActionsProps>) {
	return (
		<ActionsInline xs={24}>
			<Row align="middle" justify="center" style={{ gap: 8 }}>
				{items?.slice(0, 4).map((item) => (
					<div key={item.key}>{item.label}</div>
				))}
			</Row>
		</ActionsInline>
	);
}
